module.exports = __webpack_public_path__ + "static/media/jimmy_dal.be6b23a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/jimmy_dal.mp3
// module id = uR4t
// module chunks = 1